import {AfterViewInit, Component, OnInit} from '@angular/core';
import {
    ControlService,
    IconService,
    ScheduleService,
    SubtitlesService
} from "../../../core";
import {MenuType} from "../../../models";

@Component({
    selector: 'schedule-plus-minus',
    templateUrl: './schedule-plus-minus.component.html',
    styleUrls: ['./schedule-plus-minus.component.scss']
})
export class SchedulePlusMinusComponent implements OnInit, AfterViewInit {
    constructor(
        public control: ControlService,
        private icon: IconService,
        private subtitles: SubtitlesService,
        public schedule: ScheduleService,
    ) {
    }

    ngOnInit() {
        this.schedule.setScheduleTable();
    }

    ngAfterViewInit() {
        this.control.setOverflow();
    }

    setIcon(val: number | MenuType): string {
        if (val === null) return;

        return this.icon.setIcon(val);
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }

    itemIndex(index: number){
        return index;
    }
}
